<template>
  <div class="my_group" :class="{'isiOSX1':isiOSX}">
    <van-nav-bar
      title="我的群"
      right-text="群政策解读"
      :fixed="true"
      left-arrow
      @click-left="reBack"
      @click-right="groupRule"
      :class="{'isiOSX':isiOSX}"
    />
    <div class="box">
      <div class="group_leader_info">
        <p class="describe">我的累计奖励积分</p>
        <p class="integral">{{memberInfo.total_reward_credits}} <span @click="rewardDetails">奖励明细<img src="../../assets/xiaobaGroup/next_1@2x.png" /></span></p>
        <p class="group">群级别Q{{memberInfo.group_level}} | 群代码{{memberInfo.group_code}}</p>
      </div>
      <div class="content">
        <div class="group_member">
          <span class="border"></span>
          <p class="member_num">群成员名单·{{groupMemberCount}}人</p>
          <p class="achievement">推广商家总计<span class="sales_num">{{totalValidShop}}</span>奖励积分总计<span>{{totalRewardCredits}}</span></p>
        </div>
        <div class="search" :class="{'all_time_search':selectData=='全部时间'}">
          <div class="left" @click="showDatePopup">{{selectData}} <span></span></div>
          <span v-show="isSearch==1" class="search_btn" @click="search">搜索</span>
          <div class="right" :class="{'start_Search':isSearch==1}">
            <img src="../../assets/xiaobaGroup/search_icon@2x.png" />
            <van-cell-group>
              <van-field clearable v-model="phone" @focus="wantSearch" placeholder="会员手机号" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" maxlength="12" />
            </van-cell-group>
          </div>
        </div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="list">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="别拉了，小巴也是有底线的"
            @load="onLoad"
          >
            <van-row class="member_list">
              <van-col span="24" v-for="(item, index) in list" :key="index">
                <div class="member_info" @click="specificMerchant(item)">
                  <img class="avatar" :src="item.head_url" @error="defaultAvatar()" />
                  <span class="status" v-if="item.member_status==-4">注销</span>
                  <span class="status" v-if="item.member_status==-2">封号</span>
                  <img class="next" src="../../assets/xiaobaGroup/next_2@2x.png" />
                  <p class="phone"><img v-if="item.member_level==40" src="../../assets/xiaobaGroup/lever_vip@2x.png" /><img v-if="item.member_level==50 || item.member_level==20 || item.member_level==30" src="../../assets/xiaobaGroup/lever_city@2x.png" /> {{item.member_phone}}</p>
                  <p class="join_time">加入时间 {{item.created_at}}</p>
                  <p class="number"><span class="sales_num">{{item.valid_shop_num}}</span><span>{{item.reward_credits}}</span></p>
                  <p class="secribe"><span class="sales">推广有效商家</span><span>奖励积分</span></p>
                </div>
              </van-col>
            </van-row>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <van-popup v-model="showdate" position="bottom">
      <van-datetime-picker
        @cancel="cancel"
        @confirm="confirm($event,'selectData')"
        :formatter="formatter"
        v-model="currentDate"
        type="year-month"
        :min-date="minDate"
      />
      <p class="all_time" @click="allTime">全部时间</p>
    </van-popup>
  </div>
</template>
<script>
import avatarDefault from "@/assets/common/avatar.png";
export default {
  data() {
    return {
      isiOSX: false,
      memberInfo: {},
      groupMemberCount: '',
      totalValidShop: '',
      totalRewardCredits: '',
      phone: '',
      isSearch: 0,
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 0,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      showdate: false,
      selectData: '全部时间',
      parmYearMonth: '',
      currentDate: new Date(),
      minDate: new Date(2021, 0, 1),
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(this.$route.query.token);
    this.getInfo();
    // this.getMmber();
  },
  methods: {
    getInfo() {
      this.$api
        .get("/member-relation/member/group/basic/info")
        .then(res => {
          this.memberInfo = res;
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    getMmber() {
      this.$api
        .post("/member-relation/member/group/member/list", {
          phone: this.phone,
          year_month: this.parmYearMonth,
          page: this.page,
        })
        .then((res) => {
          this.allList = res.total;
          this.groupMemberCount = res.group_member_count;
          this.totalValidShop = res.total_valid_shop;
          this.totalRewardCredits = res.total_reward_credits;
      
          if (res.list.length > 0) {
            for(let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getMmber();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getMmber();
    },
    showDatePopup() {
      this.showdate = true;
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`;
      }
      return value;
    },
    confirm(value, item) {
      this.showdate = false;
      var year = value.getFullYear();
      var month = value.getMonth() + 1;
      this.selectData = year + "年" + month + "月";
      this.parmYearMonth = year +(month < 10 ? "0" + month : "" + month);
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    allTime() {
      this.showdate = false;
      this.selectData = "全部时间";
      this.parmYearMonth = '';
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    cancel() {
      this.showdate = false;
    },
    wantSearch() {
      this.isSearch = 1;
    },
    search() {
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    defaultAvatar() {
      var img = event.srcElement;
      img.src = avatarDefault;
      img.onerror = null; //防止闪图
    },
    reBack() {
      this.$router.go(-1);
    },
    groupRule() {
      this.$router.push({
        path: "/xiaobaGroup/groupRule",
        query: {
          type: 1,
          from: 1,
          token: this.$route.query.token
        }
      });
    },
    rewardDetails() {
      this.$router.push({
        path: "/xiaobaGroup/rewardDetails",
        query: {
          type: 1,
          token: this.$route.query.token
        }
      });
    },
    specificMerchant(item) {
      sessionStorage.setItem("groupMemberInfo", JSON.stringify(item));
      
      this.$router.push({
        path: "/xiaobaGroup/specificMerchant",
        query: {
          token: this.$route.query.token
        }
      });
    }
  }
};
</script>
<style>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }
</style>
<style lang="less" scoped>
.my_group {
  min-height: 100%;
  box-sizing: border-box;
  background: #F5F6F7;
  padding-top: 72px;
  .van-popup {
    .all_time {
      position: absolute;
      top: 30px;
      right: 0;
      text-align: center;
      z-index: 9;
      width: 100%;
      line-height: 44px;
      background: #fff;
      font-size: 14px;
    }
  }
  /deep/.van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 28px;
    border: none;
    box-shadow: none;
    background: #F9591B;
    overflow: hidden;
    .van-nav-bar__title {
      color: #ffffff;
      font-size: 1.8rem;
      font-weight: 400;
    }
    .van-nav-bar__text {
      color: #ffffff;
      font-size: 1.6rem;
      font-weight: 400;
      // padding: 0 1.2rem;
    }
    .van-icon {
      color: #ffffff;
    }
  }
  .van-hairline--bottom:after {
    border-bottom-width: 0px !important;
  }
  .van-hairline--top-bottom::after {
    border-width: 0 0; 
  }
  .isiOSX {
    padding-top: 44px;
  }
  .box {
    .group_leader_info {
      color: #fff;
      height: 11.1rem;
      background: #F9591B;
      padding: 2.1rem 1.2rem 1.2rem;
      margin-top: -0.1rem;
      box-sizing: border-box;
      .describe {
        font-size: 1.3rem;
        height: 2.1rem;
        line-height:2.1rem;
      }
      .integral {
        font-size: 2rem;
        font-weight: bold;
        height: 3.2rem;
        line-height:3.2rem;
        span {
          font-size: 1.4rem;
          font-weight: normal;
          float: right;
          img {
            width: 1.2rem;
            display: inline-block;
          }
        }
      }
      .group {
        color: rgba(255, 255, 255, .64);
        font-size: 1.3rem;
        margin-top: 0.4rem;
        height: 2.1rem;
        line-height:2.1rem;
      }
    }
    .content {
      height: auto;
      background: #ffffff;
      padding: 1.2rem 1.2rem 0;
      margin-top: 1.2rem;
      .group_member {
        padding: 0 0 1.8rem 1.3rem;
        position: relative;
        .border {
          width: 0.4rem;
          height: 4.1rem;
          background: #F9591B;
          position: absolute;
          top: 0.3rem;
          left: 0;
        }
        .member_num {
          color: #333;
          font-size: 1.5rem;
          font-weight: bold;
          height: 2.4rem;
          line-height: 2.4rem;
        }
        .achievement {
          color: #999;
          font-size: 1.3rem;
          height: 2.3rem;
          line-height: 2.3rem;
          span {
            font-weight: bold;
            font-size: 1.4rem;
            margin-left: 0.3rem;
          }
          .sales_num {
            margin-right: 1.5rem;
          }
        }
      }
      .search {
        height: 3.2rem;
        line-height: 3.2rem;
        margin-bottom: 0.8rem;
        position: relative;
        .left {
          width: 9.9rem;
          color: #333;
          font-size: 1.4rem;
          position: relative;
          // float: left;
          position: absolute;
          top: 0;
          left: 0;
          span {
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #333;
            position: absolute;
            right: 1.5rem;
            top: 1.5rem;
          }
        }
        .right {
          width: 25.2rem;
          background: #F5F6F7;
          border-radius: 0.6rem;
          padding: 0.6rem 0.9rem 0.6rem 3.5rem;
          box-sizing: border-box;
          float: right;
          position: relative;
          img {
            width: 2rem;
            display: inline-block;
            position: absolute;
            left: 0.9rem;
            top: 0.6rem;
          }
          .van-cell-group {
            width: 21.7rem;
            height: 2rem;
            background-color: #F5F6F7;
            .van-cell {
              padding: 0;
              height: 2rem;
              line-height: 2rem;
              background-color: #F5F6F7;
              padding-right: 4px;
              .van-field__control {
                color: #ccc;
              }
            }
          }
        }
        .start_Search {
          width: 21.2rem;
          .van-cell-group {
            width: 17.7rem;
          }
        }
        .search_btn {
          width: 4rem;
          text-align: right;
          color: #F9591B;
          font-size: 1.4rem;
          height: 2.3rem;
          line-height: 2.3rem;
          float: right;
          margin-top: 0.4rem;
        }
      }
      .all_time_search {
        .left {
          width: 8.5rem;
        }
        .right {
          width: 26.6rem;
        }
        .start_Search {
          width: 22.6rem;
          .van-cell-group {
            width: 19.1rem;
          }
        }
      }
      .member_list {
        width: 100%;
        background: #fff;
        .member_info {
          height: 11.05rem;
          padding: 1.3rem 0 1.2rem 4.8rem;
          box-sizing: border-box;
          border-bottom: solid 0.05rem #eee;
          position: relative;
          .avatar {
            width: 3.6rem;
            height: 3.6rem;
            border-radius: 1.8rem;
            position: absolute;
            left: 0;
            top: 1.4rem;
          }
          .status {
            color: #fff;
            width: 3.6rem;
            height: 3.6rem;
            line-height: 3.6rem;
            text-align: center;
            border-radius: 1.8rem;
            font-size: 1rem;
            position: absolute;
            left: 0;
            top: 1.4rem;
            z-index: 2;
            background: rgba(0, 0, 0, 0.6);
          }
          .next {
            width: 1.2rem;
            position: absolute;
            right: 1.2rem;
            top: 5rem;
          }
          .phone {
            color: #333;
            font-size: 1.4rem;
            height: 2.3rem;
            line-height: 2.3rem;
            img {
              height: 2rem;
              margin-right: 0.4rem;
              vertical-align: middle;
            }
          }
          .join_time {
            color: #ccc;
            font-size: 1.1rem;
            height: 1.8rem;
            line-height: 1.8rem;
          }
          .number {
            height: 2.4rem;
            line-height: 2.4rem;
            margin-top: 0.6rem;
            color: #333;
            font-size: 1.5rem;
            font-weight: bold;
            .sales_num {
              width: 9.3rem;
              display: inline-block;
            }
          }
          .secribe {
            height: 1.8rem;
            line-height: 1.8rem;
            color: #666;
            font-size: 1.1rem;
            .sales {
              width: 9.3rem;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
.isiOSX1 {
  padding-top: 88px;
}
</style>


